/** @format */

import { Badge, IconButton, SvgIcon, Tooltip } from '@mui/material';
import Bell01Icon from '@untitled-ui/icons-react/build/esm/Bell01';
import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { usePopover } from 'src/hooks/use-popover';
import { readAllNotification, removeNotification, selectNotifications } from 'src/store/app-slice';
import { NotificationsPopover } from './notifications-popover';

import { debounce } from 'lodash';
import { useServerError } from 'src/hooks/use-server-error';

export const NotificationsButton = () => {
  const popover = usePopover();
  const dispatch = useDispatch();
  const { processError } = useServerError();
  const { unread, messages } = useSelector(selectNotifications);
  // console.log(unread, messages);

  const handleRemoveOne = useCallback(
    debounce(async (notificationId) => {
      // console.log(notificationId);
      try {
        // await notificationService.deleteDoc(notificationId);
        dispatch(removeNotification(notificationId));
      } catch (error) {
        console.log('handleRemoveOne error ', error);
        processError(error);
      }
    }, 200),
    []
  );

  const handleMarkAllAsRead = useCallback(
    debounce(async () => {
      if (unread > 0) {
        try {
          // await notificationService.markAllAsRead(messageIds);
          dispatch(readAllNotification());
        } catch (error) {
          console.log('handleMarkAllAsRead error ', error);
          processError(error);
        }
      }
    }, 200),
    [messages, unread]
  );

  return (
    <>
      <Tooltip title="Thông báo">
        <IconButton ref={popover.anchorRef} onClick={popover.handleOpen}>
          <Badge color="error" badgeContent={unread}>
            <SvgIcon>
              <Bell01Icon
                sx={{
                  cursor: 'pointer'
                }}
              />
            </SvgIcon>
          </Badge>
        </IconButton>
      </Tooltip>
      <NotificationsPopover
        anchorEl={popover.anchorRef.current}
        notifications={messages}
        onClose={popover.handleClose}
        onMarkAllAsRead={handleMarkAllAsRead}
        onRemoveOne={handleRemoveOne}
        open={popover.open}
      />
    </>
  );
};
